import { DataSource, Layout } from "@mcleod/components";
import { FreightItemTable } from "../FreightItemTable";

export abstract class AutogenLayoutQuoteFreightItemTable extends Layout {
    layoutFreightItemTable: FreightItemTable;
    sourceQuoteFreightGroupItem: DataSource;
}
